module.exports = __webpack_public_path__ + "static/img/ic_down_m.100c0d1f.png";